<template>
    <div class="accordion" role="tablist">
        <b-card v-for="item in items" border-variant="white" :key="item.title" no-body class="mb-2">
            <b-card-header class="p-1 border-transparent" role="tab">
                <b-button block v-b-toggle="'acc-' + item.id">
                    <span class="h6">{{ item.title }}</span>
                </b-button>
            </b-card-header>
            <b-collapse
                :id="'acc-' + item.id"
                accordion="my-accordion"
                role="tabpanel"
            >
                <b-card-body id="descripcionFaq" class="d-flex flex-column">
                    <b-card-text v-html="item.description" />
                    <b-button :to="{ name: link, params: { faq_id: item.id} }" class="ml-auto">Mostrar más</b-button>
                </b-card-body>
            </b-collapse>
        </b-card>
    </div>
</template>

<script>
export default {
    props: ['items', 'link'],
    created() {
        this.setButtonColor()
    },
    computed: {
        manager() {
            return this.$store.getters.getFooter
        },
        colorButton() {
            return this.manager ? this.manager.altcolor : 'black'
        },
        textColorButton() {
            return this.manager ? this.manager.alttextcolor : 'lightgray'
        }
    },
    methods: {
        setButtonColor() {
            document.documentElement.style.setProperty('--main-color', this.colorButton)
            document.documentElement.style.setProperty('--text-color', this.textColorButton)
        }
    },
}
</script>

<style scoped>
button:focus,
button:hover {
    background-color: var(--main-color);
    color: var(--text-color);
}

#descripcionFaq {
    background-color: #e8e9eb;
    border-radius: 5px;
}
</style>
